import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Powerpagestemplate extends Component {
 
  render() {
    const course =[

      {
        title: "Introduction to Power Pages",
        content: [
        "What are Power Pages?",
        "How do Power Pages work?",
        "Creating your first Power Page"
        ]
        },
        {
        title: "Power Pages Components",
        content: [
        "Using the Page Builder",
        "Creating Components",
        "Using Dynamic Data",
        "Working with Forms"
        ]
        },
        {
        title: "Page Navigation and Routing",
        content: [
        "Navigation Menus",
        "Routes and Paths",
        "Dynamic Routes"
        ]
        },
        {
        title: "Styling Power Pages",
        content: [
        "CSS and Power Pages",
        "Using Custom Stylesheets",
        "Styling Components"
        ]
        },
        {
        title: "Deploying Power Pages",
        content: [
        "Preparing for Deployment",
        "Uploading to a Server",
        "Domain Setup"
        ]
        },
        {
        title: "Dynamic Data Sources",
        content: [
        "API Integration",
        "JSON and XML Data",
        "Database Integration"
        ]
        },
        {
        title: "Power Pages and WordPress",
        content: [
        "WordPress Integration",
        "Creating WordPress Pages with Power Pages",
        "Working with WordPress Themes"
        ]
        },
        {
        title: "Advanced Power Pages Features",
        content: [
        "Custom Functions",
        "Power Pages Extensions",
        "Using Third-Party Libraries"
        ]
        },
        {
        title: "Testing and Debugging",
        content: [
        "Using the Developer Console",
        "Debugging Techniques",
        "Testing Strategies"
        ]
        },
        {
        title: "Security and Performance",
        content: [
        "Security Best Practices",
        "Performance Optimization Techniques",
        "Power Pages Caching"
        ]
        },
    ]

    const faqData = [
      {
        question: 'What is Power Pages Training?',
        answer:
          'Power Pages Training is a specialized program designed to equip individuals with the skills and knowledge needed to create dynamic and visually appealing web pages using HTML, CSS, and JavaScript',
      },
      {
        question: 'Why is Power Pages Training important?',
        answer:
          'Power Pages Training is essential for professionals seeking to build interactive and responsive web pages that engage users and enhance the user experience',
      },
      {
        question: 'What topics are covered in Power Pages Training?',
        answer:
          'Power Pages Training at the best training centre covers essential topics such as HTML fundamentals, CSS styling techniques, JavaScript interactivity, responsive design principles, and best practices for web development',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with Power Platform skills can pursue a variety of career opportunities such as Data Analyst, Business Analyst, Application Developer, and Process Automation Specialist'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into Power Pages at the Best Training Centre. Our Power Pages training program welcomes individuals from diverse backgrounds, providing them with the skills and knowledge required to excel in creating dynamic and engaging web pages. Whether you're a beginner with no prior coding experience or an experienced web developer looking to enhance your skills, our courses cater to learners at every level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential Power Pages concepts, including HTML, CSS, JavaScript, and responsive design. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to thrive in mastering Power Pages with the best training centre. Join us and unlock your potential in Power Pages at the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Dhana Lakshmi",
          date:" july 09 ,2023",
          review:`learnsoft.org ${this.props.title} training in ${this.props.location} stands out as a leading training provider in ${this.props.location}. Their expertise in Power Platform training has made them a top choice for students in the region. With a team of experienced trainers, learnsoft.org is committed to delivering high-quality education that empowers students to excel.`
        },
          
          { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`learnsoft.org ${this.props.title} training in ${this.props.location} stands out as a leading training provider in ${this.props.location}. Their expertise in Power Platform training has made them a top choice for students in the region. With a team of experienced trainers, learnsoft.org is committed to delivering high-quality education that empowers students to excel.`
        
        },
  ]
     return(
      <>
        
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Microsoft Power Pages is a secure, enterprise-grade, low-code software as a service (SaaS) platform for creating, hosting, and administering modern external-facing business websites. Whether you&apos;re a low-code maker or a professional developer, Power Pages enables you to rapidly design, configure, and publish websites that seamlessly work across web browsers and devices.Power Pages is the newest member of the Microsoft Power Platform family. With Power Pages, you can build sites by using the same shared business data stored in Microsoft Dataverse that you use for building apps, workflows, intelligent virtual agents, reports, and analytics with other Microsoft Power Platform components in your organization."/> */}
           
          <NewMainsec rating='4.0' students={"299"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Microsoft Power Pages is a secure, enterprise-grade, low-code software as a service (SaaS) platform for creating, hosting, and administering modern external-facing business websites. Whether you&apos;re a low-code maker or a professional developer, Power Pages enables you to rapidly design, configure, and publish websites that seamlessly work across web browsers and devices.Power Pages is the newest member of the Microsoft Power Platform family. With Power Pages, you can build sites by using the same shared business data stored in Microsoft Dataverse that you use for building apps, workflows, intelligent virtual agents, reports, and analytics with other Microsoft Power Platform components in your organization."/>         
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Power Pages ${this.props.location1} is a popular field with a growing demand for professionals with Power Pages skills. At Learnsoft.org, we offer top-notch Power Pages training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Power Pages principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Power Pages or looking to expand your skillset, Learnsoft.org's Power Pages ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Power Pages journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Power Pages course covers a wide range of content, including website creation, page design, and marketing automation. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Power Pages. By the end of the course, you will be able to implement Power Pages practices in your own projects."}/>
  	</section>
 <Batchtime title={this.props.title} offer="24,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou1="Power Platform" coupath1="power-platform" cou='PowerApps' coupath='powerapps' cou2='Power BI' coupath2='power-bi' cou3='Power Automate' coupath3='power-automate' cou4='Tableau' coupath4='tableau'
          cou5='Salesforce' coupath5='salesforce' cou6='Dynamics 365' coupath6='dynamic365' cou7='Robotic Process Automation' coupath7='rpa'
          cou9='R Programining' coupath9='rprogram' cou8='Azure Data Engineering' coupath8='azure-data-engineering'  cou10='Pega' coupath10='pega' />

      </>
    );
  }
}
